export const DMS_ROOT_PATH = 'dms';
export const DMS_FILE_SEGMENT_PATH = 'file';
export const DMS_FILE_ID_PATH = ':fileId';
export const DMS_FILE_PATH = `${DMS_FILE_SEGMENT_PATH}/${DMS_FILE_ID_PATH}`;
export const DMS_SEARCH_PATH = 'search';
export const DMS_FILES_PATH = 'files';
export const DMS_RECENT_SEGMENT_PATH = 'recent';
export const DMS_RECENT_FILES_PATH = `${DMS_RECENT_SEGMENT_PATH}/${DMS_FILES_PATH}`;

export enum IrisDmsFolderType {
  Folder = 'Folder',
  SystemFolder = 'SystemFolder',
}

export enum IrisDmsFolderViewTab {
  Documents = 0,
  Tags = 1,
  SystemFolders = 2,
  Trash = 3,
}

export const TABS_ROUTES = {
  folders: {
    tabId: IrisDmsFolderViewTab.Documents,
    path: 'folders',
  },
  tags: {
    tabId: IrisDmsFolderViewTab.Tags,
    path: 'tags',
  },
  systemFolders: {
    tabId: IrisDmsFolderViewTab.SystemFolders,
    path: 'system-folders',
  },
  trashBin: {
    tabId: IrisDmsFolderViewTab.Trash,
    path: 'trash-bin',
  },
};

export enum IrisDmsFolderViewTabType {
  Documents = 'Documents',
  Tags = 'Tags',
  SystemFolders = 'SystemFolders',
  Trash = 'Trash',
}